module.exports = __webpack_public_path__ + "static/media/update.457919eb.svg";